import { render, staticRenderFns } from "./CostsSummary.vue?vue&type=template&id=0973c636&scoped=true"
import script from "./CostsSummary.vue?vue&type=script&lang=js"
export * from "./CostsSummary.vue?vue&type=script&lang=js"
import style0 from "./CostsSummary.vue?vue&type=style&index=0&id=0973c636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973c636",
  null
  
)

export default component.exports